import { Box } from '@components/gassan-ui'
import { FC } from 'react'

const Spacer: FC = () => {
  return <Box height={{ _: '3rem', small: '7rem' }} />
}

export default Spacer
